import * as React from "react";

import { Margins } from "@ui/Atoms";

import { useTranslate } from "@hooks/useTranslate";

import { useModalStore } from "@app/hooks/useModalStore";
import { Modal } from "@app/containers/Modal";

import { WhatIsIncluded } from "../EndOfTenancyProcess/sections";

import { END_OF_TENANCY_MODALS_ENUM } from "./EndOfTenancy.modals.types";

const WhatIsIncludedModal = (): React.ReactElement => {
  const { hideModal } = useModalStore();
  const translate = useTranslate("batmaid_pwa_end_of_tenancy");

  return (
    <Modal
      title={translate("modal_what_is_included_title")}
      id={END_OF_TENANCY_MODALS_ENUM.WHAT_IS_INCLUDED}
      submit={() => {
        hideModal(END_OF_TENANCY_MODALS_ENUM.WHAT_IS_INCLUDED);
      }}
      withCancelBtn={false}
      submitBtnColor={"blue"}
      submitText={translate("modal_what_is_included_submit_text")}
      withContainedHeight
    >
      <Margins xs={["base", "base_x2", null, null]}>
        <WhatIsIncluded />
      </Margins>
    </Modal>
  );
};

export { WhatIsIncludedModal };

WhatIsIncludedModal.displayName = "WhatIsIncludedModal";
